export const ids = [
	'floor',
	'roof',
	'frame',
	//
	'subFloor',
	'firstFloor',
	'secondFloor',
	//
	'ewp',
	//
	'flooring', // [ROME-4752] Deprecated, replaced with 'wholeHouseFlooring' ancillary item.
	//
	'wholeHouse',
	//
	'bor', // [ROME-2976] for Carters
	//
	'lintel', // [ROME-3241] FutureBuild
	'rafters', // [ROME-3241] FutureBuild
	//
	'stickFraming', // [ROME-3398] Big river
	'maxiwall', // [ROME-3398] Big river
	'maxifloor', // [ROME-3567] Big river
	//
	'trimJoist', // [ROME-5322] BV
	//
	'cassette', // [ROME-6711] Futurebuild LVL
] as const;
